import type { GenericTranslationsObject } from '@payloadcms/translations'

export const hy: GenericTranslationsObject = {
  $schema: './translation-schema.json',
  'plugin-seo': {
    almostThere: 'Գրեթե պատրաստ է',
    autoGenerate: 'Ինքնաշարժ գեներացիա',
    bestPractices: 'լավագույն փորձեր',
    characterCount: '{{current}}/{{minLength}}-{{maxLength}} նիշ, ',
    charactersLeftOver: '{{characters}} նիշ ավել է մնացել',
    charactersToGo: '{{characters}} նիշ մնացել է',
    charactersTooMany: '{{characters}} նիշ չափազանց շատ է',
    checksPassing: '{{current}}/{{max}} ստուգումները հաջող են անցել',
    good: 'Լավ',
    imageAutoGenerationTip: 'Ինքնաշարժ գեներացիան կվերցնի ընտրված հերոս նկարը։',
    lengthTipDescription:
      'Սա պետք է լինի {{minLength}}-ից {{maxLength}} նիշի սահմաններում։ Որակյալ մետա նկարագրություններ գրելու համար տես ',
    lengthTipTitle:
      'Սա պետք է լինի {{minLength}}-ից {{maxLength}} նիշի սահմաններում։ Որակյալ մետա վերնագրեր գրելու համար տես ',
    missing: 'Բացակայում է',
    noImage: 'Նկար չկա',
    preview: 'Նախադիտում',
    previewDescription:
      'Իրական արդյունքների ցուցադրումը կարող է տարբեր լինել՝ բովանդակության և որոնման համապատասխանության հիման վրա։',
    tooLong: 'Չափազանց երկար է',
    tooShort: 'Չափազանց կարճ է',
  },
}
